import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Auth.css';

const Verify2FA = () => {
  const [code, setCode] = useState(['', '', '', '', '', '']);
  const [error, setError] = useState('');
  const [verifying, setVerifying] = useState(false);
  const navigate = useNavigate();
  const { verify2FA, tempEmail } = useAuth();

  // Redirect if not coming from login
  React.useEffect(() => {
    if (!tempEmail) {
      navigate('/login');
    }
  }, [tempEmail, navigate]);

  const handleCodeChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;
    const newCode = [...code];
    newCode[index] = value;
    setCode(newCode);

    if (value && index < 5) {
      document.getElementById(`code-${index + 1}`).focus();
    }
  };

  const handleCodeKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !code[index] && index > 0) {
      document.getElementById(`code-${index - 1}`).focus();
    }
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    setError('');
    setVerifying(true);

    const fullCode = code.join('');
    if (fullCode.length !== 6) {
      setError('Please enter a 6-digit code');
      setVerifying(false);
      return;
    }

    const result = await verify2FA(fullCode);
    setVerifying(false);

    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error || 'Verification failed');
      setCode(['', '', '', '', '', '']);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1>Two-Factor Authentication</h1>
        <p className="auth-subtitle">Enter the code from your authenticator app</p>

        {error && <div className="alert alert-danger">{error}</div>}

        <form onSubmit={handleVerify}>
          <div className="form-group">
            <label className="form-label">6-digit code</label>
            <div className="code-input-container">
              {[0, 1, 2, 3, 4, 5].map((index) => (
                <input
                  key={index}
                  id={`code-${index}`}
                  type="text"
                  maxLength="1"
                  className="code-input"
                  value={code[index]}
                  onChange={(e) => handleCodeChange(index, e.target.value)}
                  onKeyDown={(e) => handleCodeKeyDown(index, e)}
                  disabled={verifying}
                  autoFocus={index === 0}
                />
              ))}
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-block"
            disabled={verifying}
          >
            {verifying ? 'Verifying...' : 'Verify'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Verify2FA;
